import GeneralSurveyManager from './GeneralSurveyManager';

// Hardcoded GeneralSurvey.Id used by the backend (GeneralSurveyUserEventProcessor) to
// grant users with the TDOEDataDashboardSurveyEntry permission visibility into all
// UserSurveyMap entries tied to the TDOE / Tennessee Data Dashboard survey.
const TDOE_DATA_DASHBOARD_GENERAL_SURVEY_ID = "FF727803-B273-44BC-B181-E7D44CD1C46E";

class DataDashboardSurveyManager extends GeneralSurveyManager {
    constructor(observationMgr, globalItemState, globalAuthState, globalAppUserState) {
        super(observationMgr, globalItemState, globalAuthState, globalAppUserState);
        this._doSearch = async () =>
            (await this._userSurveyMapSvc.getOperation("GeneralSurveyUser", '', { generalSurveyId: TDOE_DATA_DASHBOARD_GENERAL_SURVEY_ID })).first();
    }
}

export default DataDashboardSurveyManager;
